import { json } from '@remix-run/node'
import { useLoaderData } from '@remix-run/react'
import { Step, Stepper, StepperNavigation } from '#app/components/navigation/stepper.js'
import { readSource } from '../sections/sections.server.tsx'
import { Description, Source, type componentProps, Styling, Usage, Features } from '../sections/sections.tsx'

export const handle = {
	breadcrumb: 'Stepper',
}

const component: componentProps = {
	name: 'Stepper',
	shortName: 'Stepper',
	fileName: 'stepper',
	category: 'navigation',
	description: ['Indicate progress through numbered steps in multi-step workflows.'],
	features: ['Supports client-side routing.'],
	parts: [
		{
			name: 'Link',
			description: 'Indicate progress through numbered steps in multi-step workflows.',
		},
	],
	usage: ``,
	styling: ``,
}

export const loader = async () => {
	const source = await readSource({ category: component.category, fileName: component.fileName })
	return json({ source })
}

const LinkRoute = () => {
	const { source } = useLoaderData<typeof loader>()
	const { name, description, usage, shortName, fileName, styling } = component

	return (
		<>
			<Description name={name} description={description} />
			<Usage usage={usage} shortName={shortName} />
			<Stepper>
				<Step>
					<div className="bg-muted-100 h-48 w-48 rounded-lg p-4">Content for Step 1</div>
				</Step>
				<Step>
					<div className="bg-muted-100 h-48 w-48 rounded-lg p-4">Content for Step 2</div>
				</Step>
				<Step>
					<div className="bg-muted-100 h-48 w-48 rounded-lg p-4">Content for Step 3</div>
				</Step>
				<StepperNavigation />
			</Stepper>
			<Features features={component.features} />
			<Source source={source} fileName={fileName} />
			<Styling styling={styling} />
		</>
	)
}
export default LinkRoute
